// @ts-nocheck
import { orderDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDate";
import { css } from "styled-components";

const dateStyle = {
    css: css`
        ${({ theme }) => `
            font-size: ${theme.design.typography.size.large};
            font-weight: ${theme.design.typography.weight.bold};
        `}
    `,
};

Object.assign(orderDateStyles, {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
    titleText: dateStyle,
    orderDate: {
        ...dateStyle,
        css: css`
            margin-left: 0.5em;
        `,
    },
});
